import { render, staticRenderFns } from "./EventCards.vue?vue&type=template&id=c2cdc254&"
import script from "./EventCards.vue?vue&type=script&lang=js&"
export * from "./EventCards.vue?vue&type=script&lang=js&"
import style0 from "./EventCards.vue?vue&type=style&index=0&id=c2cdc254&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports